export default "__VITE_ASSET__f47c6631__"